module.exports = __webpack_public_path__ + "static/media/progress.2ac32523.jpg";